<div class="visually-hidden">
  <h1>Signing you in</h1>
  <p>Please wait while we complete sign-in and redirect you.</p>
</div>
